export type ParsedRecipe = {
  title: string;
  servings: number;
  ingredients: Array<{ qty?: string; unit?: string; name: string; notes?: string }>;
  steps: Array<{ text: string; timer_sec?: number }>;
};

export function parsePasted(text: string): ParsedRecipe {
  const lines = text.split(/\r?\n/).map((l) => l.trim());
  let section: "none" | "ingredients" | "steps" = "none";
  const ingredients: ParsedRecipe["ingredients"] = [];
  const steps: ParsedRecipe["steps"] = [];
  let title = "";

  for (const raw of lines) {
    const line = raw.replace(/^[-•*]\s?/, "").trim();
    if (!line) continue;
    const lower = line.toLowerCase();
    if (lower.startsWith("title:")) {
      title = line.slice(6).trim();
      continue;
    }
    if (lower.startsWith("servings:")) {
      // ignore for now in minimal
      continue;
    }
    if (/^ingredients:?$/i.test(line)) {
      section = "ingredients";
      continue;
    }
    if (/^(steps|method|directions):?$/i.test(line)) {
      section = "steps";
      continue;
    }

    if (section === "ingredients") {
      // naive split: qty unit name, e.g., "1 cup sugar" or "2 eggs"
      const m = line.match(/^(\d+[\d/.]*)?\s*([a-zA-Z]+)?\s*(.*)$/);
      const name = m?.[3]?.trim() || line;
      const qty = m?.[1]?.trim();
      const unit = m?.[2]?.trim();
      ingredients.push({ name, qty, unit });
    } else if (section === "steps") {
      const text = line.replace(/^\d+\.?\s*/, "");
      // detect timer like (10 min) or [5m]
      let timer: number | undefined;
      const tm = text.match(/(\d+)\s*(min|m|minutes)/i) || text.match(/(\d+)\s*(sec|s|seconds)/i);
      if (tm) {
        const n = parseInt(tm[1]!, 10);
        const unit = tm[2]!.toLowerCase();
        timer = unit.startsWith("m") ? n * 60 : n;
      }
      steps.push({ text, timer_sec: timer });
    } else {
      // before any section, assume maybe title
      if (!title) title = line;
    }
  }

  return {
    title: title || "Untitled Recipe",
    servings: 1,
    ingredients,
    steps,
  };
}
